export const envelope = {
	className: 'icon-envelope',
	viewBox: '0 0 236.93101 174.69201',
	paths: ['m 0,174.692 236.931,0 L 236.931,0 0,0 0,174.692 Z m 118.464,-47.312 30.079,-29.7 63.108,62.3 -186.372,0 63.107,-62.3 30.078,29.7 z m 40.549,-40.037 63.204,-62.386 0,124.782 -63.204,-62.396 z m -40.549,19.354 -93.185,-91.984 186.373,0 -93.188,91.984 z m -40.547,-19.354 -63.204,62.396 0,-124.782 63.204,62.386 z']
}
